import React, { useState } from 'react';
import { BuroCombobox } from './BuroCombobox';
import { BuroPortal, fechaHora } from './helpers';

/*
 * P7 · Historial de cambios (bitácora buro_fila_cambios). `cambios` lo debe
 * mandar el detalle del reporte; hoy el backend no lo expone y la pantalla no
 * muestra el botón (ver api.js). Forma esperada de cada cambio:
 * { id, fecha, usuario, numero_cuenta, columna_label, columna, antes, despues,
 *   aplicado_en_sistema, motivo }
 */
export const BuroHistorial = ({ cambios, filas, inicial = '', onClose }) => {
  const [filtro, setFiltro] = useState(inicial);
  const items = cambios.filter((c) => !filtro || c.numero_cuenta === filtro);
  return (
    <BuroPortal>
      <div className="bu-panel" style={{ width: 480 }}>
        <div className="bu-panel-head" style={{ flexDirection: 'column', gap: 14 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <h3 style={{ flex: 1 }}>Historial de cambios</h3>
            <button type="button" className="bu-icon-btn" onClick={onClose} aria-label="Cerrar"><i className="pi pi-times" /></button>
          </div>
          {/* "Todos" va como primera opción (valor vacío) y el resto se busca por cuenta o cliente. */}
          <BuroCombobox
            ariaLabel="Filtrar por contrato"
            placeholder="Busca por cuenta o cliente"
            options={[{ value: '', label: 'Todos los contratos' }, ...filas.map((f) => ({ value: f.numero_cuenta, label: `${f.numero_cuenta} · ${f.cliente}` }))]}
            value={filtro}
            onChange={setFiltro}
          />
        </div>
        <div style={{ flex: 1, overflow: 'auto' }}>
          {items.map((c) => (
            <div key={c.id} className="bu-hist-item">
              <div className="bu-hist-meta">
                <span>{fechaHora(c.fecha)}</span><span>·</span><span>{c.usuario}</span><span>·</span><b>{c.numero_cuenta}</b>
                {c.aplicado_en_sistema && <span className="bu-hist-sis">También en sistema</span>}
              </div>
              <div style={{ fontSize: 13, fontWeight: 500 }}>
                {c.columna_label || 'Columna'} <span style={{ color: '#94A3B8', fontWeight: 400 }}>· {c.columna === 0 ? '*' : c.columna}</span>
              </div>
              <div className="bu-hist-diff">
                <span className="a">{c.antes || '(vacío)'}</span>
                <i className="pi pi-arrow-right" style={{ fontSize: 10, color: '#94A3B8' }} />
                <span className="d">{c.despues || '(vacío)'}</span>
              </div>
              {c.motivo && <div className="bu-sub" style={{ fontSize: 12 }}>Motivo: {c.motivo}</div>}
            </div>
          ))}
          {items.length === 0 && <div className="bu-msg">Sin cambios registrados.</div>}
        </div>
      </div>
    </BuroPortal>
  );
};

export default BuroHistorial;
